<template>
  <v-card class="devPanel pa-3" flat elevation="0">
    <v-row no-gutters>
      <v-col cols="12" md="3">
        <v-card-title class="devHeader ma-3"> {{ $t('app.routes.developer') }} </v-card-title>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" lg="3" align="center">
        <EmulatorPanel />
      </v-col>
      <v-col cols="12" lg="9" align="center">
        <EmulatorTable />
      </v-col>
    </v-row>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import EmulatorTable from '@/components/developerPanel/emulatorTable.vue'
import EmulatorPanel from '@/components/developerPanel/emulatorPanel.vue'

export default defineComponent({
  name: 'DeveloperPanel',
  components: { EmulatorTable, EmulatorPanel }
})
</script>

<style lang="scss" scoped>
.devPanel {
  background-color: transparent;

  .devHeader {
    font-weight: 300;
    font-size: 24px;
    padding: 0;
  }
}
</style>
